module.exports = __webpack_public_path__ + "img/form_warn.4a3ea504.png";